/** @format */

import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { toast } from "react-toastify";
import domesticTariffServices from "../../Services/domesticTariffServices";
import locationServices from "../../Services/locationServices";
import Loader from "../../Components/Loader";

export const AddDomesticTariff = () => {
  const [countryList, setCountryList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [countryValue, setCountryValue] = useState("");
  const [originCityValue, setOriginCityValue] = useState("");
  const [destinationCityValue, setDestinationCityValue] = useState("");
  const [loader, setLoader] = useState(true);

  const history = useHistory();
  const formik = useFormik({
    initialValues: {
      domestic_tariff_country: "",
      domestic_tariff_origin: "",
      domestic_tariff_destination: "",
      domestic_tariff_minimum_upto_count: "",
      domestic_tariff_minimum_upto_amount: "",
      domestic_tariff_every_additional_amount: "",
      domestic_tariff_maximum_amount: "",
    },
    validationSchema: Yup.object({
      domestic_tariff_country: Yup.string().required("Required"),
      domestic_tariff_origin: Yup.string().required("Required"),
      domestic_tariff_destination: Yup.string().required("Required"),
      domestic_tariff_minimum_upto_count: Yup.string().required("Required"),
      domestic_tariff_minimum_upto_amount: Yup.string().required("Required"),
      domestic_tariff_every_additional_amount: Yup.string().required(
        "Required"
      ),
      domestic_tariff_maximum_amount: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      setLoader(true);
      let postData = {
        ...values,
      };
      domesticTariffServices.add_domestic_tariff(postData).then((res) => {
        if (res.status) {
          setLoader(false);
          history.push("/domestic-tariff-list");
        } else {
          setLoader(false);
          toast.error(res.message);
        }
      });
    },
  });

  useEffect(() => {
    getCountryList();
  }, []);

  const getCityList = (id) => {
    let param = {
      country_id: id.value,
    };
    locationServices.getCity(param).then((res) => {
      if (res.status) {
        let arry = [];
        res.data.map((list) => {
          arry.push({
            value: list._id,
            label: list.city_name,
            data: list,
          });
        });

        setCityList(arry);
        setDestinationCityValue("");
        let activeCity = arry.filter((item) => item.data.city_name === "Dubai");
        if (activeCity.length) {
          formik.setValues({
            ...formik.values,
            domestic_tariff_country: id.value,
            domestic_tariff_origin: activeCity[0].value,
            domestic_tariff_destination: "",
          });
          setOriginCityValue(activeCity[0]);
        } else {
          formik.setValues({
            ...formik.values,
            domestic_tariff_country: id.value,
            domestic_tariff_origin: "",
            domestic_tariff_destination: "",
          });
          setOriginCityValue("");
        }
        setLoader(false);
      }
    });
  };

  const getCountryList = () => {
    let param = { page: 1, limit: 300 };
    locationServices.getCountry(param).then((res) => {
      console.log('aa=====',res)
      if (res.status) {
        let arry = [];
        res.data.map((list) => {
          arry.push({ value: list._id, label: list.country_name, data: list });
        });
        let activeCountry = arry.filter(
          (item) => item.data.country_currency === "AED"
        );
        if (activeCountry.length) {
          onSelectCountry(activeCountry[0]);
        }
        setLoader(false);
        setCountryList(arry);
      } else {
        toast.error(res.message);
      }
    });
  };

  const onSelectCountry = (e) => {
    getCityList(e);
    setCountryValue(e);
  };

  const onSelectCity = (e, act) => {
    let arry = cityList;
    let newArry = [];
    arry.map((list) => {
      newArry.push({ ...list, isdisabled: list.value === e.value });
    });
    setCityList(newArry);
    switch (act) {
      case "origin":
        setOriginCityValue(e);
        formik.setValues({ ...formik.values, domestic_tariff_origin: e.value });

        break;
      case "destination":
        setDestinationCityValue(e);
        formik.setValues({
          ...formik.values,
          domestic_tariff_destination: e.value,
        });

        break;
    }
  };

  return (
    <div className="row d-flex justify-content-center">
      <div className="col-lg-8">
        <div className="card">
          <div className="card-body">
            <form className="control-form">
              <div className="row">
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Country </label>
                  </div>
                  <div className="col-9">
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: formik.touched.domestic_tariff_country
                            ? !formik.errors.domestic_tariff_country
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                          boxShadow: "0 0 0 0px #f46a6a",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      value={countryValue}
                      onChange={(e) => onSelectCountry(e)}
                      options={countryList}
                      isDisabled
                    />
                    {formik.touched.domestic_tariff_country &&
                    formik.errors.domestic_tariff_country ? (
                      <div className="text-danger">
                        {formik.errors.domestic_tariff_country}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Tariff origin</label>
                  </div>
                  <div className="col-9">
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: formik.touched.domestic_tariff_origin
                            ? !formik.errors.domestic_tariff_origin
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                          boxShadow: "0 0 0 0px #f46a6a",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      value={originCityValue}
                      // isOptionDisabled={(option) => option.isdisabled}
                      onChange={(e) => onSelectCity(e, "origin")}
                      options={cityList}
                    />
                    {formik.touched.domestic_tariff_origin &&
                    formik.errors.domestic_tariff_origin ? (
                      <div className="text-danger">
                        {formik.errors.domestic_tariff_origin}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Tariff destination</label>
                  </div>
                  <div className="col-9">
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: formik.touched
                            .domestic_tariff_destination
                            ? !formik.errors.domestic_tariff_destination
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                          boxShadow: "0 0 0 0px #f46a6a",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      value={destinationCityValue}
                      // isOptionDisabled={(option) => option.isdisabled}
                      onChange={(e) => onSelectCity(e, "destination")}
                      options={cityList}
                    />
                    {formik.touched.domestic_tariff_destination &&
                    formik.errors.domestic_tariff_destination ? (
                      <div className="text-danger">
                        {formik.errors.domestic_tariff_destination}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Minimum Up To KG</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.domestic_tariff_minimum_upto_count
                          ? !formik.errors.domestic_tariff_minimum_upto_count
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps(
                        "domestic_tariff_minimum_upto_count"
                      )}
                      placeholder="Enter Minimum UpTo KG"
                    />
                    {formik.touched.domestic_tariff_minimum_upto_count &&
                    formik.errors.domestic_tariff_minimum_upto_count ? (
                      <div className="text-danger">
                        {formik.errors.domestic_tariff_minimum_upto_count}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">
                      Minimum Up to KG Amount
                    </label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.domestic_tariff_minimum_upto_amount
                          ? !formik.errors.domestic_tariff_minimum_upto_amount
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps(
                        "domestic_tariff_minimum_upto_amount"
                      )}
                      placeholder="Enter Minimum Upto Amount"
                    />
                    {formik.touched.domestic_tariff_minimum_upto_amount &&
                    formik.errors.domestic_tariff_minimum_upto_amount ? (
                      <div className="text-danger">
                        {formik.errors.domestic_tariff_minimum_upto_amount}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">
                      Every Additional / KG Amount
                    </label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.domestic_tariff_every_additional_amount
                          ? !formik.errors
                              .domestic_tariff_every_additional_amount
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps(
                        "domestic_tariff_every_additional_amount"
                      )}
                      placeholder="Enter Every Additional / KG Amount"
                    />
                    {formik.touched.domestic_tariff_every_additional_amount &&
                    formik.errors.domestic_tariff_every_additional_amount ? (
                      <div className="text-danger">
                        {formik.errors.domestic_tariff_every_additional_amount}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Maximum Up to Amount</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.domestic_tariff_maximum_amount
                          ? !formik.errors.domestic_tariff_maximum_amount
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps(
                        "domestic_tariff_maximum_amount"
                      )}
                      placeholder="Enter Maximum Upto Amount"
                    />
                    {formik.touched.domestic_tariff_maximum_amount &&
                    formik.errors.domestic_tariff_maximum_amount ? (
                      <div className="text-danger">
                        {formik.errors.domestic_tariff_maximum_amount}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="mt-3 d-flex justify-content-between">
                <button
                  className="btn btn-danger w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => formik.handleSubmit()}
                >
                  Submit
                </button>
              </div>
            </form>
            <Loader isShow={loader} />
          </div>
        </div>
      </div>
    </div>
  );
};
